import postRequest from 'utils/postRequest'
import getRequest from 'utils/getRequest'
import deleteRequest from 'utils/deleteRequest'
import putRequest from 'utils/putRequest'
import filterUndefinedFromObject from 'utils/filterUndefinedFromObject'
import qs from 'query-string'
import patchRequest from 'utils/patchRequest'

const path = '/api/site-specie'
const reassessmentPath = '/api/reassessment/sites'
const csvPath = '/api/csv'

const shouldMockSensitiveSpeciesError = () =>
  globalThis.window !== undefined &&
  globalThis.sessionStorage?.getItem('mockSensitiveSpeciesError') === '1'

export const requestCreateSiteSpecie = (siteId, payload, siteHistoryId, signal) => {
  if (shouldMockSensitiveSpeciesError()) {
    return Promise.resolve({ error: 'sensitiveSpeciesHiddenForIndividual' })
  }

  const url = siteHistoryId
    ? `${reassessmentPath}/${siteHistoryId}/species`
    : `${path}/${siteId}`

  let body = payload
  if (typeof payload === 'string' || typeof payload === 'number') {
    body = { iucnListId: payload }
  }

  if (body === undefined || body === null) {
    body = {}
  }
  return postRequest(url, body, signal)
}


export const requestGetSiteSpecies = (siteId, siteHistoryId, {
  resultsPerPage = 8,
  currentPage = 1
}, newSpecies) => {
  const queryString = {
    resultsPerPage,
    currentPage
  }
  const queryStringParsed = qs.stringify(queryString)
  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/species/?${queryStringParsed}&newSpecie=${Boolean(newSpecies)}` : `${path}/site/${siteId}/?${queryStringParsed}`

  return getRequest(url)
}

export const requestGetAllSiteSpecies = (siteId, siteHistoryId, {
  resultsPerPage = 8,
  currentPage = 1
}) => {
  const queryString = {
    resultsPerPage,
    currentPage
  }
  const queryStringParsed = qs.stringify(queryString)
  const url = siteHistoryId
    ? `${reassessmentPath}/${siteHistoryId}/species/?${queryStringParsed}`
    : `${path}/site/${siteId}/?${queryStringParsed}`

  return getRequest(url)
}

export const requestGetSiteSpecie = (siteSpecieId, siteHistoryId, specieHistoryId) => {
  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/species/${specieHistoryId}` : `${path}/${siteSpecieId}`
  return getRequest(url)
}

export const requestDeleteSiteSpecie = (siteSpecieId, siteHistoryId, siteSpecieHistoryId) => {
  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/species/${siteSpecieHistoryId}` : `${path}/${siteSpecieId}`
  return deleteRequest(url)
}


export const requestUpdateSiteSpecie = (siteSpecieId, siteHistoryId, speciesHistoryId, {
  RedListCategoryCode,
  specieName,
  taxonomicGroup,
  equivalentSystemIfNotRedList,
  triggerReasonId,
  triggerReasonText,
  isReassessed,
  CongregationGroupId,
  criteria,
  ibaCriterias,
  reassessDateStatus,
  sensitiveAtSite,
  sensitiveAtSiteSource,
  disqualified_iba_trigger,
}) => {

  const preBody = {
    RedListCategoryCode,
    specieName,
    taxonomicGroup,
    equivalentSystemIfNotRedList,
    triggerReasonId,
    triggerReasonText,
    isReassessed,
    CongregationGroupId,
    criteria,
    ibaCriterias,
    disqualified_iba_trigger,
    reassessDateStatus,
    sensitive_at_site: sensitiveAtSite,
    sensitive_at_site_source: sensitiveAtSiteSource
  }

  const body = filterUndefinedFromObject(preBody)
  if (siteHistoryId) {
    return patchRequest(`${reassessmentPath}/${siteHistoryId}/species/${speciesHistoryId}`, body)
  }
  delete body.reassessDateStatus
  return putRequest(`${path}/${siteSpecieId}`, body)
}

export const confirmSpecies = (speciesId, siteHistoryId, isApproved) => {
  if (siteHistoryId) {
    return postRequest(`${reassessmentPath}/${siteHistoryId}/species/${speciesId}/confirm`, isApproved)
  }
  return postRequest(`${path}/${speciesId}/confirm`, isApproved)
}

export const cancelReassessmentRequest = ({ siteId, specieId, isCancelled }) => {
  return postRequest(`${reassessmentPath}/${siteId}/species/${specieId}/cancel`, { isCancelled: isCancelled })
}

export const requestGetSpeciesTemplate = () => {
  return getRequest(`${csvPath}/forms/site-species`)
}
